<template>
  <button class="main-button" v-b-tooltip.hover :title="data.name" @click="click" :disabled="data.disabled">
    <div class="circle position-relative">
      <img :src="data.icon">
      <b-badge variant="danger" v-if="data.number && data.number > 0">{{data.number > 9 ? "9+" : data.number}}</b-badge>
    </div>
    <h4>{{data.name}}</h4>
  </button>
</template>

<script>
export default {
  name: "MainButton",
  props: ["data"],
  methods: {
    click: function () {
      if (this.data.click)
        this.data.click

      this.$emit("click", this.data);
    }
  }
}
</script>

<style scoped>

</style>